var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.resData) ? _c('div', {
    staticClass: "scope-written box-shadow-small border-radius"
  }, [_c('p', {
    staticClass: "mt-10 mb-20"
  }, [_c('router-link', {
    attrs: {
      "to": "/written"
    }
  }, [_vm._v("笔试")]), _vm._v("\n        >\n        "), _c('router-link', {
    attrs: {
      "to": "/written/exam/list"
    }
  }, [_vm._v("笔试安排列表")]), _vm._v("\n        >\n        "), _c('span', [_vm._v("笔试安排详情")])], 1), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "mt-20",
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考试标题",
      "prop": "title"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.resData.exam.title) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "考生须知",
      "prop": "examRules"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.resData.exam.examRules) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择笔试题",
      "prop": "paperIds"
    }
  }, _vm._l((_vm.resData.exam.paperList), function(item, index) {
    return _c('p', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": ("/written/topic/" + (item.id) + "?resumePositionId=&examId=")
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 0), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "考试日期"
    }
  }, _vm._l((_vm.resData.exam.examTimes), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item.startTime) + "-" + _vm._s(item.endTime))])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.resData.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "候选人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.name) + "\n                ")]
      }
    }], null, false, 4089127706)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.phone) + "\n                ")]
      }
    }], null, false, 304553441)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.positionName) + "\n                ")]
      }
    }], null, false, 3608179427)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历来源",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm.getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeSource) || '-') + "\n                ")]
      }
    }], null, false, 2124748343)
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.backToExanmList
    }
  }, [_vm._v("关闭")])], 1)], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76de8b82"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/writtenArrangementDetail.vue
// module id = null
// module chunks = 